/**
 * Convert large integers in JSON text to strings to prevent precision loss.
 * Numbers with 16+ digits that exceed Number.MAX_SAFE_INTEGER are wrapped in quotes.
 *
 * This is critical for Milvus auto-generated INT64 IDs which exceed JS safe integer range.
 */
export function makeBigIntSafe(text: string): string {
  return text.replaceAll(
    /(?<=[:,[]\s*)(-?\d{16,})(?=\s*[,}\]\n\r])/g,
    (match) => {
      const abs = match.startsWith('-') ? match.slice(1) : match
      return abs.length > 15 || (abs.length === 15 && abs > '9007199254740991') ? `"${match}"` : match
    }
  )
}
